/* src/app/components/promo-code/promo-code.component.scss */
.add-promocode-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: black;
  color: white !important;
  border-radius: var(--custom-border-radius);
  box-shadow: 0px 0px 42px 0px rgba(0, 0, 0, 0.0705882353);
  padding: 5px 5px;
}
.add-promocode-wrapper ion-icon {
  width: 22px;
  height: 22px;
}
.add-promocode-wrapper {
  margin-bottom: 10px;
}
.delete-promo {
  margin-left: 5px;
}
.title {
  font-size: 14px;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
}
.promo-icon-button {
  height: 20px;
  width: 20px;
  padding: 5px;
  border: 2px solid red;
}
.border-line {
  border: 1px solid #000000;
}
/*# sourceMappingURL=promo-code.component.css.map */
